/**
 * Homepage — print production calculator (Alpine component)
 */
import Alpine from 'alpinejs';

export default function kalkulatorFile() {
  return {
    GAP: 0.7,
    preset: 'custom',
    materialW: '',
    materialH: '',
    unitMaterialW: 'cm',
    unitMaterialH: 'cm',
    jenisCetak: 'cetak_saja',
    fileW: '',
    fileH: '',
    unitFileW: 'cm',
    unitFileH: 'cm',
    showInteger: true,
    hasResult: false,
    errorMsg: '',
    result: {
      slotW: 0,
      slotH: 0,
      perRow: 0,
      perCol: 0,
      totalFrac: 0,
      totalInt: 0,
    },

    init() {},

    applyPreset() {
      if (this.preset === 'custom') {
        this.materialW = '';
        this.materialH = '';
        this.unitMaterialW = 'cm';
        this.unitMaterialH = 'cm';
      } else {
        const dims = this.preset.split('|');
        this.materialW = parseFloat(dims[0]);
        this.materialH = parseFloat(dims[1]);
        this.unitMaterialW = 'cm';
        this.unitMaterialH = 'cm';
      }
      this.resetResult();
    },

    toCm(val, unit) {
      const v = parseFloat(val);
      if (!isFinite(v) || v <= 0) return NaN;
      if (unit === 'mm') return v / 10;
      if (unit === 'm') return v * 100;
      return v;
    },

    fmt(n, d = 4) {
      return isFinite(n) ? parseFloat(n.toFixed(d)) : '-';
    },

    hitung() {
      this.errorMsg = '';
      this.hasResult = false;
      const mW = this.toCm(this.materialW, this.unitMaterialW);
      const mH = this.toCm(this.materialH, this.unitMaterialH);
      const fW = this.toCm(this.fileW, this.unitFileW);
      const fH = this.toCm(this.fileH, this.unitFileH);

      if (!isFinite(mW) || !isFinite(mH) || !isFinite(fW) || !isFinite(fH)) {
        this.errorMsg = 'Mohon lengkapi semua data angka.';
        return;
      }

      const slotW = this.jenisCetak === 'cetak_cutting' ? fW + this.GAP : fW;
      const slotH = this.jenisCetak === 'cetak_cutting' ? fH + this.GAP : fH;

      if (slotW > mW || slotH > mH) {
        this.errorMsg = this.jenisCetak === 'cetak_cutting'
          ? 'Ukuran file + spasi melebihi ukuran bahan.'
          : 'Ukuran file melebihi ukuran bahan.';
        return;
      }

      const perRow = mW / slotW;
      const perCol = mH / slotH;
      const totalFrac = perRow * perCol;
      const totalInt = Math.floor(perRow) * Math.floor(perCol);

      this.result = { slotW, slotH, perRow, perCol, totalFrac, totalInt };
      this.hasResult = true;

      this.$nextTick(() => {
        document.getElementById('hasil-kalkulator')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    },

    reset() {
      this.preset = 'custom';
      this.materialW = '';
      this.materialH = '';
      this.unitMaterialW = 'cm';
      this.unitMaterialH = 'cm';
      this.jenisCetak = 'cetak_saja';
      this.fileW = '';
      this.fileH = '';
      this.unitFileW = 'cm';
      this.unitFileH = 'cm';
      this.showInteger = true;
      this.resetResult();
    },

    resetResult() {
      this.hasResult = false;
      this.errorMsg = '';
    },
  };
}

Alpine.data('kalkulatorFile', kalkulatorFile);
